import Primus from 'primus-client';
const socket = new Primus(process.env.SPORTSBOOK_API, {headers: { 'bookmaker': process.env.BOOKMAKER }});
window.socket = socket;
const webstore = require('store2');

import sportify from 'sportify'
import Auth from 'netbet/auth';
let auth = new Auth({bookmaker: process.env.BOOKMAKER})
sportify.setAuth(auth)
import localforage from 'localforage';
import N from 'precise-number'
import _ from 'lodash'

export default ({ app, $axios, store, req }, inject) => {
  
    inject('socket', () => {
        return window.socket;
    })
  
  inject('webstore', () => {
    return webstore.local;
  })


  inject('cache', () => {
    let store = localforage.createInstance({
      driver: localforage.LOCALSTORAGE,
      name: 'sportify',
      version: 1.0,
      storeName: 'cache',
      description: 'sportify cache'
    });
    return store;
  })  

  inject('sportify', () => {
    window.sportify = sportify
    return sportify;
  })


  inject('auth', () => {
    const defaultOptions = {
      baseURL: app.$config.AUTH_API,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('jwt'),
      },
    };

    let instance = app.$axios.create(defaultOptions);
    instance.interceptors.request.use(function (config) {
      for (let dbgFlg of JSON.parse(localStorage.getItem('debug_flags') ?? '[]')) {
        if (dbgFlg.state === true) {
          config.headers[dbgFlg.name] = 1;
        }
      }
      config.headers.jwt =  localStorage.getItem('jwt');
      return config;
    });
    return instance
  })  

  inject('math', () => {
    return {
      multiply(a, b) {
        a = _.defaultTo(a, 0)
        b = _.defaultTo(b, 0)
        return N.multiply(a, b)
      },
      add(a, b) {
        a = _.defaultTo(a, 0)
        b = _.defaultTo(b, 0)
        return N.add(a, b)
      },
      subtract(a, b) {
        a = _.defaultTo(a, 0)
        b = _.defaultTo(b, 0)
        return N.sub(a, b)
      },
      divide(a, b) {
        a = _.defaultTo(a, 0)
        b = _.defaultTo(b, 0)
        return N.divide(a, b)
      },
      chain(value) {
        return N(value)
      },
      parse(value) {
        return N.parse(value)
      }
    }
  })

}
